import React from 'react';
import { useRouteError } from 'react-router';

export function RouteErrorBoundary(): React.JSX.Element {
	const error = useRouteError();

	// it bubbles up to be captured by the outer ErrorBoundary
	throw error;
}
